module.exports = __webpack_public_path__ + "media/images/vp/bg.authcols-6d3bbfb6287bfe34545f1091e30da2c5.svg";